import { toApiError } from '../lib/api/api-error';
import { Alert } from './alert';

interface ErrorMessageProps {
  error: unknown;
  title?: string;
}

/** Mensagem de erro da API. Em erros inesperados, mostra discretamente o código para suporte. */
export function ErrorMessage({ error, title }: ErrorMessageProps) {
  if (!error) return null;
  const apiError = toApiError(error);
  return (
    <Alert tone="danger" title={title}>
      <p>{apiError.message}</p>
      {apiError.correlationId && apiError.isUnexpected && (
        <p className="support-code">Código para suporte: {apiError.correlationId}</p>
      )}
    </Alert>
  );
}

interface ErrorStateProps {
  error: unknown;
  title?: string;
  onRetry?: () => void;
}

export function ErrorState({
  error,
  title = 'Não foi possível carregar os dados.',
  onRetry,
}: ErrorStateProps) {
  const apiError = toApiError(error);
  return (
    <div className="error-state">
      <Alert tone="danger" title={title}>
        <p>{apiError.message}</p>
        {apiError.correlationId && (
          <p className="support-code">Código para suporte: {apiError.correlationId}</p>
        )}
      </Alert>
      {onRetry && (
        <button type="button" className="btn btn--secondary" onClick={onRetry}>
          Tentar novamente
        </button>
      )}
    </div>
  );
}
